function randomChar() {
  let s = ''
  const random = () => {
    const code =
      (Math.random() * 10).toFixed() % 2
        ? Math.floor(Math.random() * 26) + 'A'.charCodeAt(0)
        : Math.floor(Math.random() * 26) + 'a'.charCodeAt(0)
    return String.fromCharCode(code) // A-Z
  }
  while (s.length < 15) {
    s += random()
  }
  return s
}

export function getNetworkState() {
  const functionName = randomChar()
  return new Promise((resolve, reject) => {
    if (window.kwaiying) {
      window.kwaiying.getNetWorkState(
        JSON.stringify({
          callback: functionName,
        })
      )
      window[functionName] = function (data) {
        let result = ''
        if (data) {
          result = data.state
          delete window[functionName]
        }
        resolve(result)
      }
    } else {
      reject(new Error('No bridge'))
    }
  })
}

export function getAppInfo(name) {
  const functionName = randomChar()
  return new Promise((resolve, reject) => {
    if (window.kwaiying) {
      window.kwaiying.getInfoFromKwaiYing(
        JSON.stringify({
          infoName: name,
          callback: functionName,
        })
      )
      window[functionName] = function ({ result }) {
        delete window[functionName]
        resolve(result)
      }
    } else {
      console.info("getAppInfo No bridge")
      reject(new Error('No bridge'))
    }
  })
}

export function photoPick() {
  const functionName = randomChar()
  return new Promise((resolve, reject) => {
    if (window.kwaiying) {
      window.kwaiying.open(
        JSON.stringify({
          url: 'kwaiying://pick',
          callback: functionName,
        })
      )
      window[functionName] = function (data) {
        delete window[functionName]
        resolve(data)
      }
    } else {
      reject(new Error('No bridge'))
    }
  })
}
export function uploadUserMaterialZip() {
  const functionName = randomChar()
  return new Promise((resolve, reject) => {
    if (window.kwaiying && window.kwaiying.uploadUserMaterialZip) {
      window.kwaiying.uploadUserMaterialZip(
        JSON.stringify({ callback: functionName })
      )
      window[functionName] = function (data) {
        delete window[functionName]
        resolve(data)
      }
    } else {
      reject(new Error('No bridge'))
    }
  })
}

export function selectFileAndUpload(
  params,
  singleResultCallBack,
  progressCallBack
) {
  const resultFunName = randomChar() + 'resultFunName'
  const progressFunName = randomChar() + 'progressFunName'
  const singleResultFunName = randomChar() + 'singleResultFunName'
  window[progressFunName] = progressCallBack
  window[singleResultFunName] = singleResultCallBack
  console.log('=======', singleResultFunName, progressFunName)
  window?.kwaiying?.selectFileAndUpload?.(
    JSON.stringify({
      arguments: params,
      singleResultCallBack: singleResultFunName,
      progressCallBack: progressFunName,
      taskResultCallBack: resultFunName,
    })
  )
  return new Promise((resolve, reject) => {
    window[resultFunName] = function (data) {
      delete window[resultFunName]
      delete window[progressFunName]
      delete window[singleResultFunName]
      resolve(data)
    }
  })
}
